import http from '../http';

const groupUserManange = {
    /**
     * 获取用户组下拉列表
     */
    getGroupListCut() {
        return http.post(`/work_order/groupuser/getGroupListCut`);
    },
}
export default groupUserManange;
